module.exports = __webpack_public_path__ + "img/tic-logo-white.e009fd86.png";